<div *ngIf="mostLeastData" class="card p-3 mb-3"
  [ngClass]="(type === 'measure' && done) ? 'valid' : (type === 'measure' && !done) ? 'invalid' : ''">
  <div class="container py-3">

    <!-- only choice THSarabun use own scss -->
    <h4 class="text-left mt-3 mb-3">

      <span *ngIf="isAutoNumber"
        [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THsarabun-Header' : font === 'K2D' ? 'K2D' : ''">{{ mostLeastData.NUMBER }}.
        {{ mostLeastData.VALUE[0].question }}</span>

      <span *ngIf="!isAutoNumber"
        [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THsarabun-Header' : font === 'K2D' ? 'K2D' : ''">{{ questionNumber }}.
        {{ mostLeastData.VALUE[0].question }}</span>
      <!-- {{ mostLeastData.NUMBER }}. {{ mostLeastData.VALUE[0].question }} -->
    </h4>

    <div *ngIf="mostLeastData.VALUE[0].media.file_url">
      <div class="d-flex justify-content-center">

        <!-- image -->
        <img *ngIf="mostLeastData.VALUE[0].media.media_type === 'image'" [src]="mostLeastData.VALUE[0].media.file_url"
          alt="" class="img-fluid my-3 mx-auto d-block" style="width: 855px;"><br>

        <!-- video -->
        <plyr *ngIf="mostLeastData.VALUE[0].media.media_type === 'vdo'" class="plyr" id="video"
          style="display: block; width: 855px;" plyrTitle="Video 1" [plyrSources]="videoSources"
          (plyrInit)="player = $event;" (plyrEnded)="vdoEnable(time_again)" (plyrTimeUpdate)="currentvdoTime()">
        </plyr>

        <!-- sound -->
        <div *ngIf="mostLeastData.VALUE[0].media.media_type === 'sound'">
          <mat-card class="d-flex justify-content-between mb-3"
            style="width: 240px; border-radius: 30%; border-top-left-radius: 30px; border-bottom-left-radius: 30px; border-top-right-radius: 30px; border-bottom-right-radius: 30px; padding: 5px 5px 5px 5px;">

            <a *ngIf="audioBtnStatus" style="padding: 5px 10px 5px 10px;"
              (click)="playAudio(mostLeastData.ID, time_again)">
              <img src="assets/play-button-w.png" style="width: 30px;" alt="">
            </a>
            <a *ngIf="!audioBtnStatus" disabled style="padding: 5px 10px 5px 10px;">
              <img src="assets/play-button-disabled.png" style="width: 30px;" alt="">
            </a>
            <h6 style="margin-top: 12px; margin-right: 17px">
              <span
                [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THSarabun' : font === 'K2D' ? 'K2D' : ''">
                {{ audCurrentTime | number: '1.2-2' }}
              </span>
              <span
                [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THSarabun' : font === 'K2D' ? 'K2D' : ''">
                / {{ mostLeastData.VALUE[0].media.duration / 100 | number: '1.2-2' }}
              </span>
            </h6>
          </mat-card>
          <p class="text-primary text-center" *ngIf="!unlimit"
            [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THsarabun-choice' : font === 'K2D' ? 'K2D' : ''">
            *เล่นได้อีก {{ time_again }} ครั้ง
          </p>
          <audio [id]="mostLeastData.ID" type="audio/mp3" (ended)="auEnable(time_again)"
            (timeupdate)="currentaudTime(mostLeastData.ID)">
            <source [src]="mostLeastData.VALUE[0].media.file_url">
          </audio>
        </div>

      </div>

      <!-- video play button -->
      <div *ngIf="mostLeastData.VALUE[0].media.media_type === 'vdo'" style="margin-bottom: 50px;">
        <div class="border mb-3"
          style="border-bottom-left-radius: 30px; border-bottom-right-radius: 30px; padding: 5px 5px 5px 5px;">
          <div class="row">
            <div class="col-1" style="margin: 6px 0 6px 0;">
              <a *ngIf="videoBtnStatus" style="padding: 5px 10px 5px 10px;" (click)="playVideo()">
                <img src="assets/play-button-w.png" style="width: 30px;" alt="">
              </a>
              <a *ngIf="!videoBtnStatus" disabled style="padding: 5px 10px 5px 10px;">
                <img src="assets/assets/play-button-disabled.png" width="30px" alt="">
              </a>
            </div>
            <div class="col-5">
              <h6 style="margin: 11px 0px 0px 20px;">
                <span
                  [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THSarabun' : font === 'K2D' ? 'K2D' : ''">
                  {{ vdoCurrentTime | number: '1.2-2' }} /
                  {{ mostLeastData.VALUE[0].media.duration / 100 | number: '1.2-2' }}
                </span>
              </h6>
            </div>
            <div class="col-6">
              <p class="text-primary text-right" style="margin: 12px 10px 0 0;" *ngIf="!unlimit"
                [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THsarabun-choice' : font === 'K2D' ? 'K2D' : ''">
                *เล่นได้อีก {{ time_again }} ครั้ง
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- no form -->
    <div *ngIf="!type">
      <div class="row mb-3">
        <div class="col-8"></div>
        <div class="col-2">
          <p [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THSarabun-ML' : font === 'K2D' ? 'K2D' : ''"
            class="text-center mostLeast">
            {{ mostLeastData.VALUE[0].most }}</p>
        </div>
        <div class="col-2">
          <p [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THSarabun-ML' : font === 'K2D' ? 'K2D' : ''"
            class="text-center mostLeast">
            {{ mostLeastData.VALUE[0].least }}</p>
        </div>
      </div>

      <div class="row" *ngFor="let c of mostLeastData.VALUE[0].choices">
        <div class="col-8">
          <p class="ml-3"
            [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THsarabun-choice' : font === 'K2D' ? 'K2D' : ''">
            {{ c.choice_detail }}</p>
        </div>
        <div class="col-2 d-flex justify-content-center">
          <mat-radio-group [(ngModel)]="choice1" (change)="most2(choice1)">
            <mat-radio-button class="ml-1" [value]="c.choice_id" style="margin-bottom: 3px;"></mat-radio-button><br>
          </mat-radio-group>
        </div>
        <div class="col-2 d-flex justify-content-center">
          <mat-radio-group [(ngModel)]="choice2" (change)="least2(choice2)">
            <mat-radio-button class="ml-1" [value]="c.choice_id" style="margin-bottom: 3px;"></mat-radio-button><br>
          </mat-radio-group>
        </div>
      </div>

    </div>

    <!-- have form -->
    <div *ngIf="type === 'measure' || type === 'research'">
      <div class="row mb-3">
        <div class="col-8"></div>
        <div class="col-2">
          <p class="text-center mostLeast"
            [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THSarabun-ML' : font === 'K2D' ? 'K2D' : ''">
            {{ mostLeastData.VALUE[0].most }}
          </p>
        </div>
        <div class="col-2">
          <p class="text-center mostLeast"
            [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THSarabun-ML' : font === 'K2D' ? 'K2D' : ''">
            {{ mostLeastData.VALUE[0].least }}
          </p>
        </div>
      </div>
      <div class="row" *ngFor="let c of mostLeastData.VALUE[0].choices">
        <div class="col-8">
          <p class="ml-3"
            [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THsarabun-choice' : font === 'K2D' ? 'K2D' : ''">
            {{ c.choice_detail }}
          </p>
        </div>
        <div class="col-2 d-flex justify-content-center">
          <mat-radio-group [(ngModel)]="choice1" (change)="mostChoice(choice1)">
            <mat-radio-button class="ml-1" [value]="c.choice_id"></mat-radio-button><br>
          </mat-radio-group>
        </div>
        <div class="col-2 d-flex justify-content-center">
          <mat-radio-group [(ngModel)]="choice2" (change)="leastChoice(choice2)">
            <mat-radio-button class="ml-1" [value]="c.choice_id"></mat-radio-button><br>
          </mat-radio-group>
        </div>
      </div>

    </div>

  </div>
</div>
